// Client for the Legacy SFTP Connector (Lender.Optimus.Integrations, provider key `legacy-sftp`).
// Settings, credentials and test-connection go through the shared provider endpoints on
// integrationStudioApi, and the import history through loanImportsApi; this module owns the run.

const BASE = '/api/integration-studio/legacy-sftp';

export class LegacySftpConnectorApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async run({ dryRun }) {
    return this.#http.post(`${BASE}/run`, { dryRun });
  }
}
